import { render, staticRenderFns } from "./UpForGrabs.vue?vue&type=template&id=5ac28a90"
import script from "./UpForGrabs.vue?vue&type=script&lang=js"
export * from "./UpForGrabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports